import { useEffect, useState } from 'react';
import type { WindowSize } from '../types';

/**
 * Viewport dimensions, updated on resize.
 *
 * Resize events are coalesced through `requestAnimationFrame` so a drag
 * produces one state update per frame rather than one per event.
 */
export function useWindowSize(): WindowSize {
  const [size, setSize] = useState<WindowSize>(() => ({
    width: window.innerWidth,
    height: window.innerHeight,
  }));

  useEffect(() => {
    let raf = 0;

    const onResize = (): void => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        setSize({ width: window.innerWidth, height: window.innerHeight });
      });
    };

    window.addEventListener('resize', onResize);
    return () => {
      window.removeEventListener('resize', onResize);
      cancelAnimationFrame(raf);
    };
  }, []);

  return size;
}
